var symphony = symphony || {};

symphony.siteSearch = {

    qaHosts: ["md1", "md1:8080", "md1secure", "md1secure:8443", "mdqa.salvationarmy.org"],
    isQA: false, // gets set in /symphony/search.ftl
    results: [],
    commConnResults: [],
    container: null,

    init: function () {
        this.container = document.getElementById('search-results');
        if (this.container) {
            this.query = UTIL.GetQueryStringParameterByName('query').trim();
            this.getSearchResults();
        }
    },

    getSearchResults: function () {
        var self = this;
        if (self.query.length > 0) {
            $('body').addClass('loading');

            self.query = self.query.toLowerCase();

            $.get('/' + siteUrlAlias + '/search/all?query=' + self.query)
                .done(function (response) {
                    self.results = JSON.parse(response).objects;
                })
                .always(function () {

                    if (symphony.commConnSearch.canIntegrateWithCommConn()) {
                        var searchTerm = self.query;
                        var searchType = 0;

                        // if the user is searching for a specific type of result, clear the searchTerm and set the searchType
                        if (['class', 'classes'].indexOf(searchTerm) > -1) {
                            searchTerm = '';
                            searchType = 1;
                        }
                        if (['day pass', 'day passes', 'daypass', 'daypasses'].indexOf(searchTerm) > -1) {
                            searchTerm = '';
                            searchType = 2;
                        }
                        if (['membership', 'memberships', 'join'].indexOf(searchTerm) > -1) {
                            searchTerm = '';
                            searchType = 3;
                        }

                        symphony.commConnSearch.getCommConnSalesItems(searchTerm, searchType, function (commConnList) {
                            self.commConnResults = commConnList;

                            self.commConnResults = $.grep(self.commConnResults, function (x) {
                                return [1, 2, 3].indexOf(x.resultType) > -1;
                            });

                            for (var i = 0; i < self.commConnResults.length; i++) {

                                var commConnResult = self.commConnResults[i];

                                switch (commConnResult.resultType) {
                                    case 1: // Classes
                                        if (commConnResult.classInstanceId) {
                                            commConnResult.detailsApiUrl = commConnApiUrl + '/api/sales-search/class/' + commConnResult.classInstanceId;
                                            if (commConnResult.classActivityId && commConnResult.itemType.toLowerCase() == 'drop-in') {
                                                commConnResult.salesUrl = krocSalesUrl + '/#/' + krocCenterWebId + '/dropin/' + commConnResult.classActivityId + '/';
                                            } else {
                                                commConnResult.salesUrl = krocSalesUrl + '/#/' + krocCenterWebId + '/program/' + commConnResult.classInstanceId + '/';
                                            }
                                        }
                                        break;
                                    case 2: // Day Passes
                                        if (commConnResult.membershipPlanId) {
                                            commConnResult.detailsApiUrl = commConnApiUrl + '/api/sales-search/membership-plan/' + commConnResult.membershipPlanId;
                                            if (commConnResult.membershipCategoryId) {
                                                commConnResult.salesUrl = krocSalesUrl + '/#/' + krocCenterWebId + '/daypass/package/' + commConnResult.membershipCategoryId + '/';
                                            } else {
                                                commConnResult.salesUrl = krocSalesUrl + '/#/' + krocCenterWebId + '/membership/' + commConnResult.membershipPlanId + '/';
                                            }
                                        }
                                        break;
                                    case 3: // Memberships
                                        if (commConnResult.membershipPlanId) {
                                            commConnResult.detailsApiUrl = commConnApiUrl + '/api/sales-search/membership-plan/' + commConnResult.membershipPlanId;
                                            commConnResult.salesUrl = krocSalesUrl + '/#/' + krocCenterWebId + '/membership/' + commConnResult.membershipPlanId + '/';
                                        }
                                        break;
                                }
                            }

                            wrapItUp();
                        });
                    } else {
                        wrapItUp();
                    }

                    function wrapItUp() {
                        // number the results for reference later
                        for (var i = 0; i < self.results.length; i++) {
                            self.results[i].index = i;
                            self.results[i].score = 0;
                        }
                        for (var i = 0; i < self.commConnResults.length; i++) {
                            self.commConnResults[i].index = i;
                            self.commConnResults[i].score = 200 - i;
                        }

                        // concatenate results
                        var groupedResults = [].concat(self.results, self.commConnResults);

                        function queryOccurrances(string, query) {
                            query = query || self.query;
                            return string.split(query).length - 1;
                        }

                        // score results by relevance
                        for (var i = 0; i < groupedResults.length; i++) {
                            var title = (groupedResults[i].title || groupedResults[i].name || '').toLowerCase();
                            groupedResults[i].score += (queryOccurrances(title) * 20);

                            var description = (groupedResults[i].description || groupedResults[i].marketingDescription || '').toLowerCase();
                            groupedResults[i].score += (queryOccurrances(description) * 10);

                            if (self.query.indexOf(' ') > -1) {
                                var queries = self.query.split(' ');

                                for (var ii = 0; ii < queries.length; ii++) {
                                    groupedResults[i].score += (queryOccurrances(title, queries[ii].trim()) * 2);
                                }

                                for (var ii = 0; ii < queries.length; ii++) {
                                    groupedResults[i].score += (queryOccurrances(description, queries[ii].trim()));
                                }
                            }
                        }

                        // sort results by score, then title
                        groupedResults = groupedResults.sort(function (a, b) {
                            if (a.score < b.score) {
                                return 1;
                            } else if (a.score > b.score) {
                                return -1;
                            } else {
                                var aTitle = (a.title || a.name || '').toLowerCase();
                                var bTitle = (b.title || b.name || '').toLowerCase();
                                return aTitle < bTitle ? -1 : 0;
                            }
                        });

                        self.container.innerHTML = symphony.templates['siteSearch-results']({
                            noResultsMessage: noResultsMessage && noResultsMessage.trim().length > 0 ? noResultsMessage : "Sorry, we couldn't find any results for your query.",
                            results: groupedResults
                        });

                        // load the images for the site results
                        for (var i = 0; i < self.results.length; i++) {
                            var result = self.results[i];
                            self.getPageImage({
                                imgClass: 'featuredImage-' + result.index,
                                title: result.title.trim().replace(/'/g, "\\'").replace(/\"/g, "\\\""),
                                description: result.description.trim().replace(/'/g, "\\'").replace(/\"/g, "\\\""),
                                link: result.document.preferredUrl,
                                content: '', //result.document.content,
                                image: ''
                            });
                        }

                        // load the commconn details for the commconn results
                        for (var i = 0; i < self.commConnResults.length; i++) {
                            self.renderCommConnDetails(self.commConnResults[i]);
                        }

                        symphony.expandingTextCount = 0;
                        symphony.expandingText();

                        $('body').removeClass('loading');
                    }
                });
        } else {
            self.container.innerHTML = symphony.templates['siteSearch-results']({
                noResultsMessage: "Please enter a search term and try again.",
                results: []
            });
        }
    },

    renderCommConnDetails: function (commConnResult) {
        var elm = document.querySelector('.commConn-searchResult-' + commConnResult.index)

        if (elm) {
            elm.classList.add('local-loading');
            setTimeout(function () {
                $.ajax({
                    type: 'GET',
                    url: commConnResult.detailsApiUrl,
                    contentType: 'application/json',
                    success: function (resp) {
                        elm.classList.remove('local-loading')
                        commConnResult.cachedDetails = resp.data;
                        renderIt(commConnResult);
                    },
                    error: function () {
                        if (commConnResult.cachedDetails) {
                            renderIt(commConnResult);
                        } else {
                            elm.classList.remove('local-loading')
                            if (elm.querySelector('.u-card-commConnIntegration')) {
                                elm.querySelector('.u-card-commConnIntegration').innerHTML = '<div class="u-textCenter">An error has occurred. <br />Please try again soon.</div>';
                            }
                        }
                    }
                });
            }, 300);
        }

        function renderIt(card) {
            parsedData = symphony.parseCommConnData({
                commConnData: card
            });
            if (elm.querySelector('.u-card-commConnIntegration')) {
                elm.querySelector('.u-card-commConnIntegration').innerHTML = symphony.templates['card-commConnIntegration']({
                    commConnData: card,
                    priceText: parsedData.priceText,
                    priceSubtext: parsedData.priceSubtext,
                    text: '',
                    includeMarketingDescription: true,
                    redButton: true
                });
            }
        }
    },

    getPageImage: function (page) {
        if (this.isQA) {
            page.link = page.link.replace('https://' + fullSiteDomain, window.location.protocol + '//' + window.location.host + '/' + siteUrlAlias);
            page.link = page.link.replace('http://' + fullSiteDomain, window.location.protocol + '//' + window.location.host + '/' + siteUrlAlias);
        }

        if (page.content) {
            findImage(page, page.content);
        } else {
            $.get(page.link, function (data) {
                findImage(page, data);
            }).fail(function () {
                $('.' + page.imgClass).eq(0).remove();
            });
        }

        function findImage(page, data) {
            // look for theater image
            var heroImage = $(data).find('.lazyload').data('srcset');
            if (typeof heroImage !== 'undefined') {
                if (heroImage.indexOf(' ') > -1) {
                    $('.' + page.imgClass + ' img').eq(0).attr('src', heroImage.substr(0, heroImage.indexOf(' ')));
                } else {
                    $('.' + page.imgClass + ' img').eq(0).attr('src', heroImage);
                }
            } else {
                // look for any image
                var heroImage = $(data).find('img:not(.globalHeader-logo)').eq(0).attr('src');
                if (typeof heroImage !== 'undefined') {
                    if (heroImage.indexOf(' ') > -1) {
                        $('.' + page.imgClass + ' img').eq(0).attr('src', heroImage.substr(0, heroImage.indexOf(' ')));
                    } else {
                        $('.' + page.imgClass + ' img').eq(0).attr('src', heroImage);
                    }
                } else {
                    $('.' + page.imgClass).eq(0).remove();
                }
            }
        }
    }

};
